<script setup>
import { ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import {
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/vue";
import { ChevronDownIcon } from "@heroicons/vue/24/outline";

const { t } = useI18n();

const props = defineProps({
  table: {
    type: Object,
    required: true,
  },
});

const currentPageSize = ref(props.table.getState().pagination.pageSize);

const pageSizes = [10, 25, 50, 100, 250, 500];

watch(props.table.getState(), () => {
  currentPageSize.value = props.table.getState().pagination.pageSize;
});

watch(currentPageSize, () => {
  props.table.setPageSize(currentPageSize.value);
});
</script>

<template>
  <div class="relative">
    <Listbox v-model="currentPageSize" v-slot="{ open }">
      <div class="flex items-center gap-2">
        <span class="text-sm">
          {{ t("all.label.show") }}
        </span>

        <div class="relative">
          <ListboxButton
            class="flex items-center rounded bg-gray-200 px-3 py-1 text-left text-sm text-indigo-600 duration-150 hover:bg-indigo-600 hover:text-white"
            :class="{ 'bg-indigo-600 text-white': open }"
          >
            {{ currentPageSize }}
            <ChevronDownIcon class="ml-2 h-4 w-4" />
          </ListboxButton>

          <ListboxOptions
            class="absolute left-0 top-10 z-50 w-full rounded bg-white drop-shadow-md"
          >
            <ListboxOption
              v-for="(pageSize, index) in pageSizes"
              :key="index"
              :value="pageSize"
              class="cursor-pointer px-3 py-1 text-sm duration-150 hover:bg-gray-100"
            >
              {{ pageSize }}
            </ListboxOption>
          </ListboxOptions>
        </div>
      </div>
    </Listbox>
  </div>
</template>
